/* eslint-disable import/no-restricted-paths */
import {
  AssetId,
  CreateQuestionInSection,
  CreateSection,
  EntityId,
  GraphComponentType as RawGraphComponentType,
  GraphEntity as RawGraphEntity,
  LoginMethodMin,
  SubGraph as RawSubGraph,
  WhoAmIResponse,
  ErrorResponse,
  WhoAmIOnAccountResponse,
} from "./generatedTypes";

export type {
  Account,
  AccountType,
  Activity,
  ActivityStream,
  AnswerParts,
  AnswerReviewParts,
  ApiDateTime,
  ApiDate,
  BackgroundTask,
  CompleteBackgroundTask,
  PendingBackgroundTask,
  BulkQuestionAction,
  BulkQuestionUpdate,
  BulkQuestionUpdateItem,
  CommentPayload,
  Config,
  Counterparty,
  CreateAutoComplete,
  CreateEditSystemAgent,
  CreateComment,
  CreateCounterparty,
  CreateDocument,
  CreateDocumentSource,
  CreateQuestionnaireDocumentation,
  CreateDocumentationAttachment,
  CreateExternalAuthorization,
  CreateExternalNonce,
  CreatedExternalNonce,
  CreateMention,
  CreateQuestion,
  CreateQuestionDocumentation,
  ControlGroupMin,
  CreateQuestionnaire,
  CreateSection,
  CreateQuestionInSection,
  CreateStandaloneFile,
  CreateRegisteredUser,
  Document,
  DocumentMin,
  DocumentationAttachment,
  BulkRiskAction,
  BulkSourceUpdate,
  DocumentSource,
  DocumentSourceConfig,
  BulkRiskUpdate,
  DocumentSourceConnector,
  DocumentSourceMin,
  Documentation,
  CreatedExternalAuthorization,
  ExternalAuthorization,
  File,
  OriginalFile,
  OriginalSource,
  RequestLoginReset,
  FrontendEnvironment,
  InviteUser,
  ListActivitiesArgs,
  LoginRequest,
  Mention,
  PasswordConfig,
  PasswordPolicyConfig,
  Question,
  QuestionGroupMin,
  ActivitySummary,
  Questionnaire,
  QuestionnaireMin,
  AddLoginMethod,
  ReviewPeriod,
  RichText,
  RichTextAttributes,
  RichTextElement,
  SectionMin,
  QAMode,
  StandaloneFile,
  Task,
  ToolsConfig,
  UpdateDocumentContent,
  UpdateDocumentSource,
  SystemAgentUser,
  UserMin,
  TeamMin,
  RegisteredUser,
  WhoAmIResponse,
  ConfluenceDocumentSourceConfig,
  ConfluenceLabel,
  ResponseOption,
  SelectAnswerConfig,
  AnswerOption,
  Section,
  SendSupportEmail,
  Sources,
  SourcedFact,
  FactSourceQuestion,
  FactSourceDocument,
  FactTextMin,
  GenerateTotpResponse,
  UpdateTwoFa,
  LoginCredentials,
  GettingStartedChecklist,
  Rational,
  CrmConnector,
  UpdateCrmConnection,
  CreateCrmConnection,
  CrmConnection,
  CrmConnectionMin,
  CrmConnectionConfig,
  CrmAccountInfo,
  AdHocQuestion,
  CreateAdHocQuestion,
  UpdateQuestionSource,
  CreateQuestionSource,
  QuestionSource,
  QuestionSourceConfig,
  QuestionSourceAccountInfo,
  QuestionSourceMin,
  QuestionSourceConnector,
  Deal,
  ResponseLayer,
  FactMin,
  Paginated,
  PaginationArgs,
  AccountUser,
  Role,
  NotificationSink,
  NotificationSinkConnector,
  CreateNotificationSink,
  UpdateNotificationSink,
  NotificationSinkConfig,
  NotificationSinkMin,
  LinkNotificationSink,
  LinkedNotificationSinkMin,
  EsignatureProvider,
  EsignatureProviderConnector,
  EsignatureProviderConfig,
  EsignatureProviderMin,
  DocusignEsignatureProviderConfig,
  CreateEsignatureProvider,
  UpdateEsignatureProvider,
  EsignatureTemplate,
  ResetLoginInfo,
  PublicCredentials,
  AccountMin,
  CreateAccessToken,
  AccessToken,
  ConsentResponse,
  ConsentArgs,
  RequestRegistration,
  DocumentExternal,
  DocumentAccessRequest,
  TrustCenterContent,
  TrustCenterConfigMin,
  TrustCenterConfig,
  TrustCenterContentMin,
  CreateTrustCenterContent,
  IObject,
  IValue,
  TrustCenterConfigMeta,
  TrustCenterFaq,
  TrustCenterFaqQuestion,
  DownloadOptions,
  FactCluster,
  ClusteredFact,
  Asset,
  AssetMin,
  CreateAsset,
  ListAssets,
  ScopeMin,
  Scope,
  ScopeAccess,
  CreateScope,
  NotionDocumentSourceConfig,
  Resolution,
  CreateScopeAxis,
  ScopeAxisMin,
  ScopeMatrix,
  ScopeIdList,
  DeleteDocumentSourceArgs,
  FactSourceEntity,
  CreateLibrarySection,
  UpdateLibrarySection,
  LibrarySectionMin,
  FactSearchArgs,
  ListLibrarySectionFactsArgs,
  ListScopeFactsArgs,
  ReportedError,
  ReportedErrorCatalogMin,
  Team,
  CreateTeam,
  RoleMin,
  Owner,
  OwnerPayload,
  ResolveOwner,
  Uuid,
  UserId,
  OwnerId,
  QuestionId,
  QuestionGroupId,
  SectionId,
  QuestionnaireId,
  AccountId,
  CounterpartyId,
  DocumentId,
  FileId,
  StandaloneFileId,
  DocumentationId,
  TeamId,
  RoleId,
  DealId,
  ExternalAuthorizationId,
  AssetId,
  ActivityStreamId,
  BackgroundTaskId,
  FactTextId,
  FactClusterId,
  ScopeId,
  ScopeAxisId,
  EntityId,
  ContentId,
  ResolutionId,
  ErrorCatalogId,
  DocumentAccessRequestId,
  CrmConnectionId,
  DocumentSourceId,
  EsignatureProviderId,
  EsignatureTemplateId,
  NotificationSinkId,
  QuestionSourceId,
  LibrarySectionId,
  PromptModifiers,
  Invalidation,
  Fact,
  FactId,
  ScopedLibrarySectionId,
  RelevantFact,
  TrustCenterAiCheckItemConfig,
  TrustCenterAiDataUseItemConfig,
  TrustCenterDataProtectionDataUseItemConfig,
  TrustCenterDataProtectionOperatingCountriesConfig,
  TrustCenterAiModelProviderConfig,
  TrustCenterPasswordConfig,
  CoreResponse,
  CreateCoreResponse,
  CoreResponseId,
  RelevantCoreResponse,
  MailingListId,
  SubscribeRequest,
  UploadOptions,
  TrustCenterSubscribeConfig,
  MailingList,
  Subscriber,
  ShowcaseUpdateMessage,
  ShowcaseMessageIds,
  ShowcaseUpdateMessageId,
  CreateOrUpdateShowcaseUpdateMessage,
  ApikeyId,
  AssessmentId,
  ControlGroupId,
  ControlId,
  FrameworkId,
  FrameworkVersionId,
  FrameworkProfileId,
  MailSubscriptionId,
  SourceChunkId,
  SourceId,
  ThirdPartyId,
  QuestionMin,
  Nominal,
  ListResolutionsArgs,
  CountResolutionsArgs,
  Control,
  CreateThirdPartyTag,
  IdentifiedSheetSection,
  IdentifiedSheetCell,
  IdentifiedSheetRange,
  QuestionUpdatedPayload,
  ResolutionMin,
  ActivityPayload,
  SARRequest,
  ThirdPartyTierId,
  ThirdPartyTierMin,
  ThirdPartyTagId,
  ThirdPartyTagMin,
  ThirdParty,
  ThirdPartyMin,
  ThirdPartyWithQuestionnairesMin,
  CreateThirdParty,
  CreateThirdPartyTier,
  ControlGroup,
  CreateFramework,
  CreateFrameworkVersion,
  NotificationPreferencesConfig,
  UpdateNotificationPreference,
  UpdateWatcherTrigger,
  TprmScopeMin,
  CreateTprmScope,
  TprmScopeId,
  CreateSource,
  Source,
  SourceMin,
  SourceKind,
  DocumentSourceKind,
  InAppNotification,
  InAppNotificationStream,
  InAppNotificationId,
  AiModelConfig,
  CreateAssessment,
  AssessedControlIdPair,
  AssessedControl,
  Risk,
  RiskMin,
  RiskContext,
  FilterAssessments,
  RiskId,
  ControlMin,
  SourceMinKind,
  TprmQuestionnaire,
  TprmSectionTemplate,
  TprmQuestionTemplate,
  TprmQuestionTemplateId,
  TprmResponse,
  TprmAnswer,
  TprmAnswerConfig,
  FrameworkMin,
  FrameworkVersionMin,
  FrameworkProfile,
  FrameworkProfileMin,
  Assessment,
  AssessmentWithQuestionnaires,
  AssessmentMin,
  RecordRiskEvaluation,
  RecordComponentWiseRiskEvaluation,
  Actioned,
  RegisteredUserMin,
  TprmExternalQuestionnaireId,
  TprmExternalQuestionnaireExternal,
  TprmExternalAnswer,
  TprmExternalTextAnswer,
  TprmExternalSelectAnswer,
  TprmExternalFilesAnswer,
  TprmExternalSubQuestionnairesAnswer,
  TprmTextAnswerConfig,
  TprmSelectAnswerConfig,
  TprmFilesAnswerConfig,
  TprmSubQuestionnairesAnswerConfig,
  ListNotificationsArgs,
  ControlEvidenceId,
  RiskContextId,
  RecordControlAssessment,
  ControlEvidence,
  TprmQuestionnaireTemplateMin,
  TprmQuestionnaireTemplateId,
  TprmExternalQuestionnaire,
  TprmExternalQuestionnaireMin,
  CreateTprmExternalQuestionnaire,
  TprmQuestionnaireTemplate,
  RecordControlEvidence,
  RiskArea,
  RiskAreaId,
  CreateRiskContext,
  TprmCondition,
  TprmExternalResponse,
  ExternalWhoAmIResponse,
  TrustCenterAuth,
  ReportPayload,
  TprmReportTemplateId,
  TprmReportTemplate,
  CreateTprmReportTemplate,
  InvalidationCause,
  ReminderSchedule,
  ScimConfig,
  ScimConfigId,
  CreateScimConfig,
  ScimConfigList,
  VerifiedDomain,
  CreateVerifiedDomain,
  VerifiedDomainId,
  CreateRisk,
  PreLoginResponse,
  LoginMethodMin,
  LoginMethodId,
  LoginRedirectRequest,
  LoginMethod,
  ValidateLoginMethod,
  AccountWithRestriction,
  AccountRestriction,
  UserLoginMethod,
  FactGenPrompt,
  TprmAssetId,
  TprmAsset,
  CreateTprmAsset,
  UpdateTprmAsset,
  RiskQuantificationModel,
  ComponentWiseRiskQuantificationModel,
  RiskThreshold,
  RiskQuantificationModelComponent,
  HistoricRiskEvaluation,
  ComputedRiskEvaluation,
  OperationalContextId,
  OperationalContext,
  OperationalContextMin,
  CreateOperationalContext,
  UpdateOperationalContext,
  CreateServiceUser,
  ServiceUser,
  ExternalUser,
  ServiceUserApikey,
  ServiceUserApikeyMin,
  UserApikeyId,
  User,
  AssessmentSummary,
  ErrorResponse,
  AnswerPart,
  RiskIdPair,
  CreateAssessmentDecision,
  TypedAssessmentNode,
  AssessmentNode,
  RiskEvaluationContent,
  TypedAssessmentDecision,
  RecordBasicRiskEvaluation,
  AssessmentDecision,
  RecordAssessmentDecision,
  AssessedControlUpdatedPayload,
  RiskUpdatedPayload,
  DataRoomId,
  DataRoom,
  CreateDataRoom,
  PopulateRegisteredUser,
  Region,
  Apikey,
  LoginResponse,
  UpdateLoginMethodRequest,
  UpdateLoginMethodResponse,
  ResetLoginMethodResponse,
  SetPassword,
} from "./generatedTypes";

export {
  ProductType,
  SourceUsageType,
  NotificationChannelCategory,
  LoginMethodType,
  TprmScopeVisibility,
  PasswordManager,
  Sso,
  SharingClassification,
  QuestionStatus,
  ReviewStatus,
  DocumentAuthority,
  DocumentCategory,
  ExternalAuthorizationProvider,
  ExternalNonceProvider,
  QuestionnaireStatus,
  Environment,
  AiStatus,
  LayerType,
  OAuthRedirectTarget,
  SystemRole,
  NotificationSinkConnectorType,
  EsignatureProviderConnectorType,
  CustomDomainType,
  TrustCenterAccess,
  AccountFeature,
  AssetOwner,
  ResolutionType,
  OwnerType,
  nominate,
  CertificationType,
  PovModifier,
  VerbosityModifier,
  PromptModifierType,
  TrustCenterDataUseItemPii,
  TrustCenterTrustedPartneredType,
  SubscriptionAction,
  UpdateNotificationStatus,
  NotificationType,
  WatcherTrigger,
  TprmScopeType,
  AiModel,
  AiFeature,
  AIProvider,
  RiskLevel,
  AssessmentStatus,
  NotificationStatus,
  TprmConditionSelectMatchesCriteria,
  TprmConditionComparisonOperator,
  TprmReportTemplateType,
  TprmReportChartKind,
  AccessLevel,
  ColorPalette,
  RiskQuantificationCombiningFunction,
  BulkSourceAction,
  UserType,
  CacheDirective,
  AssessmentDecisionNodeType,
  SystemAgentRole,
  ExternalAccountReferenceType,
  SystemAgentDomain,
} from "./generatedTypes";

export type {
  GetGraphQuery,
  GraphOperation,
  GraphOperationEntityRef,
  GraphPropertyValueRelationship,
  GraphProperty,
  NotificationPayloadType,
  GenerateReportOpts,
  CreateReviewAction,
  ReviewAction,
  Reviewable,
  ChartContentPayload,
  ReportContentPayload,
  ReportRenderingOptions,
  WatcherPreferences,
} from "./generatedTypes";

// The frontend knows about the existence of some properties on entities.
export type GraphEntity = RawGraphEntity & {properties: Partial<KnownEntityProperties>};
export type SubGraph = Omit<RawSubGraph, "entities"> & {entities: Record<string, GraphEntity>};

// The frontend uses session authentication and so will always have a user
export type WhoAmI = WhoAmIResponse & {user: {login_method: LoginMethodMin}};
export type WhoAmIOnAccount = WhoAmIOnAccountResponse;

// We always supply questions and sections fields
export type ImportQuestions = {
  questions: CreateQuestionInSection[];
  sections: CreateSection[];
  automate?: boolean;
};

export class UnauthorizedError extends Error {
  data: ErrorResponse;

  constructor(data: ErrorResponse) {
    super("UnauthorizedError");
    this.data = data;
  }
}

// Graph known types

export type GraphComponentType = `${RawGraphComponentType}`;

export const KNOWN_ENTITY_PROPERTIES = {
  name: "String",
  country_of_registration: "String",
  companies_house_number: "String",
  duns_number: "String",
  vat_number: "String",
  ico_registration: "String",
  registered_address: "String",
  website_url: "String",
  job_title: "String",
  legal_entity_type: "String",
  trust_center_url: "String",
  description: "String",
  shared_data: "String",
  iso_country_code: "String",
  incorporation_date: "String",
  industry_type: "String",
  growth_plan: "String",
  official_legal_entity_type: "String",

  number_of_employees: "Integer",

  is_root_legal_entity: "Boolean",
  gdpr_sccs: "Boolean",
  gdpr_based_in_europe: "Boolean",
  gdpr_equivalence: "Boolean",

  photo: "Asset",

  beneficial_owner: "Relationship",
  senior_leadership: "Relationship",
  board_member: "Relationship",
  subprocessor: "Relationship",
} as const satisfies {[k: string]: GraphComponentType};

/**
 * A helper type to map from a known property enum to its TypeScript type.
 */
export type Relationship = {parent_entity_id: EntityId; child_entity_id: EntityId};
type KnownPropertyMap = {
  String: string;
  Integer: number;
  Boolean: boolean;
  Asset: AssetId;
  Relationship: Relationship;
};

export type KnownEntityPropertyOfType<V extends GraphComponentType> = {
  [K in keyof typeof KNOWN_ENTITY_PROPERTIES]: (typeof KNOWN_ENTITY_PROPERTIES)[K] extends V ? K : never;
}[keyof typeof KNOWN_ENTITY_PROPERTIES];

export type KnownEntityProperty = keyof typeof KNOWN_ENTITY_PROPERTIES;
export type KnownEntityProperties = {[K in KnownEntityProperty]: KnownPropertyMap[(typeof KNOWN_ENTITY_PROPERTIES)[K]]};

type KnownEntityPropertiesByType = {[K in GraphComponentType]: KnownEntityPropertyOfType<K>[]};

function groupEntityPropertiesByType(): KnownEntityPropertiesByType {
  const res: Partial<KnownEntityPropertiesByType> = {};
  for (const [k, v] of Object.entries(KNOWN_ENTITY_PROPERTIES)) {
    if (!Object.hasOwn(res, v)) {
      res[v] = [];
    }
    res[v]!.push(k as never);
  }
  return res as KnownEntityPropertiesByType;
}

export const KNOWN_ENTITY_PROPERTIES_BY_TYPE = groupEntityPropertiesByType();
